export default {
  getTipoPreguntaTpl: state => {
    let table = 'TipoPregunta'
    switch (state.operacion) {
      case 'edit':
      case 'new':
        table = `${table}Form`
        break
      default:
        table = `${table}List`
        break
    }
    return table
  },
}
